import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {SignatureModalComponent} from '../signature-modal/signature-modal.component';
import {IconProp} from 'ngx-satoris';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-signature-input',
  templateUrl: './signature-input.component.html',
  styleUrl: './signature-input.component.scss'
})
export class SignatureInputComponent {
  @Input() icon: IconProp;
  @Input() labelKey: string;
  @Input() description: string = '';
  @Input() hasValue: boolean = false;
  @Input() value: string;
  @Output() captured = new EventEmitter<string>();

  sanitizedValue: SafeHtml | undefined = undefined;

  displayPreview: boolean = false;

  constructor(public dialog: MatDialog, private sanitizer: DomSanitizer) { }

  ngOnChanges(changes: SimpleChanges) {
    this.sanitizedValue = this.sanitizer.bypassSecurityTrustHtml(changes.value.currentValue);
  }

  toggleDisplayPreview() {
    this.displayPreview = !this.displayPreview;
  }

  openSignatureModal(): void {
    const dialogRef = this.dialog.open(SignatureModalComponent);
    dialogRef.afterClosed().subscribe(result => {
      this.captured.emit(result);
    });
  }
}
